import { makeStyles, tokens } from '@fluentui/react-components';
import { useT } from '@powerportalspro/react';
import {
  AggregateDataverseChartDataSource,
  QueryAggregate,
  ChartLegendPosition,
  ChartType,
  type ChartClickEventArgs,
} from '@powerportalspro/react-charts';
import { DataverseChart } from '@powerportalspro/react-fluent';
import { useMemo, useState } from 'react';

// A polar area chart gives every category the same angle and lets its value set how far the slice
// reaches, so categories are compared by size rather than by share of a whole, as in a pie. Here:
// the accounts' total revenue in each industry. Click a slice to see its figure.

const STRINGS_BASE = 'components.PowerPortalsPro.Demo.Client.Customizations.Pages.Demos.ChartDemos.PolarAreaChartShowcaseMainDemo';

const useStyles = makeStyles({
  clicked: {
    marginTop: tokens.spacingVerticalM,
  },
});

export function PolarAreaChartShowcaseMainSample() {
  const styles = useStyles();
  const t = useT();
  const [clicked, setClicked] = useState<ChartClickEventArgs | null>(null);

  const revenueByIndustry = useMemo(
    () =>
      new AggregateDataverseChartDataSource({
        tableName: 'account',
        groupByColumn: 'industrycode',
        aggregateColumn: 'revenue',
        aggregate: QueryAggregate.Sum,
        singleSeriesLabel: t(`${STRINGS_BASE}.series-label`),
      }),
    [t],
  );

  return (
    <>
      <DataverseChart
        dataSource={revenueByIndustry}
        type={ChartType.PolarArea}
        title={t(`${STRINGS_BASE}.chart-title`)}
        legendPosition={ChartLegendPosition.Right}
        height="480px"
        onElementClick={setClicked}
      />
      {clicked && (
        <p className={styles.clicked}>
          {/* In dollars, as the demo's data is, whatever the page's language. */}
          <strong>{clicked.label}:</strong> ${clicked.value.toLocaleString(undefined, { maximumFractionDigits: 0 })}
        </p>
      )}
    </>
  );
}
